import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { toast } from "react-toastify";
import { useUser } from "../context/UserContext";
interface AdminRouteProps {
  children: ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const { user } = useUser();

  useEffect(() => {
    if (!user) {
      toast.info("Du må logge inn for å fortsette.");
      navigate("/");
      return;
    }

    if (!user.roles.includes("Admin") && !user.roles.includes("SuperAdmin")) {
      toast.error("Du har ikke tilgang til denne siden.");
      navigate("/main");
      return;
    }
  }, [user, navigate]);

  // Prevent flicker
  if (
    !user ||
    (!user.roles.includes("Admin") && !user.roles.includes("SuperAdmin"))
  )
    return null;

  return <>{children}</>;
};

export default AdminRoute;
